import Marquee from "react-fast-marquee";

const PHOTOS = [
  "/images/game-swing.webp",
  "https://images.unsplash.com/photo-1529768167801-9173d94c2a42?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "/images/game-times.webp",
  "/images/game-hat.webp",
  "/images/game-lineup.webp",
  "/images/game-duo.webp",
  "/images/bigcal-card.jpg",
  "/images/game-dough.webp",
  "/images/game-family.webp",
  "https://images.unsplash.com/photo-1723586762109-12527019b6a9?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "/images/logo-cutout.webp",
];

const Row = () => (
  <>
    {PHOTOS.map((p, i) => (
      <img
        key={i}
        src={p}
        alt=""
        loading="lazy"
        className="mx-3 h-40 w-auto rounded-xl border border-white/10 object-cover brightness-110 saturate-125 md:h-56"
      />
    ))}
  </>
);

export default function GamePhotoStrip() {
  return (
    <div
      aria-hidden
      data-testid="game-photo-strip"
      className="pointer-events-none absolute inset-0 overflow-hidden opacity-50 [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]"
    >
      <div className="absolute inset-x-[-15%] top-1/2 -translate-y-1/2 -rotate-3 space-y-8">
        <Marquee speed={22} gradient={false}>
          <Row />
        </Marquee>
        <Marquee speed={18} gradient={false} direction="right">
          <Row />
        </Marquee>
      </div>
    </div>
  );
}
